import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;
import Location from 'utils/Location';
import LanguageLocale from 'utils/LanguageLocale';
import basketConstants from 'constants/Basket';
import { PICKUP, SAME_DAY } from 'constants/UpperFunnel';
import EN from 'components/SiteSearch/locales/SiteSearch_en_US.js';
import FR from 'components/SiteSearch/locales/SiteSearch_fr_CA.js';

import templateSelector from 'selectors/page/templateInformation/templateSelector';
import { shopMyStoreSelector } from 'selectors/page/shopMyStore/shopMyStoreSelector';
import { shopSameDaySelector } from 'selectors/page/shopSameDay/shopSameDaySelector';
import { isShopYourStorePreselectFulfillmentEnabledSelector } from 'viewModel/selectors/shopYourStore/isShopYourStorePreselectFulfillmentEnabledSelector';
import { SYS_SEARCH_SOT_SUBTYPE } from 'analytics/bindingMethods/pages/ShopYourStore/ShopYourStoreBindings';

const { DELIVERY_OPTIONS } = basketConstants;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(EN, FR);

const storeIdSelector = createSelector(shopMyStoreSelector, shopMyStore => {
    return shopMyStore?.data?.storeDetails?.storeId;
});

const zipCodeSelector = createSelector(shopSameDaySelector, shopSameDay => {
    return shopSameDay?.data?.sameDay?.zipCode;
});

const localizationSelector = createStructuredSelector({
    searchStore: getTextFromResource(getText, 'searchStore'),
    searchLocation: getTextFromResource(getText, 'searchLocation')
});

const fields = createSelector(
    templateSelector,
    localizationSelector,
    storeIdSelector,
    zipCodeSelector,
    isShopYourStorePreselectFulfillmentEnabledSelector,
    (template, localization, storeId, zipCode, isShopYourStorePreselectFulfillmentEnabled) => {
        let refinements = null;
        let placeholder = null;
        let deliveryOption = null;
        let sotSubType = null;

        if (Location.isShopMyStorePage(template)) {
            refinements = [`${PICKUP}=${storeId}`];
            placeholder = localization.searchStore;
            sotSubType = SYS_SEARCH_SOT_SUBTYPE.SHOP_YOUR_STORE;

            if (isShopYourStorePreselectFulfillmentEnabled) {
                deliveryOption = DELIVERY_OPTIONS.PICKUP.toLocaleLowerCase();
            }
        } else if (Location.isShopSameDayPage(template)) {
            refinements = [`${SAME_DAY}=${zipCode}`];
            placeholder = localization.searchLocation;
            sotSubType = SYS_SEARCH_SOT_SUBTYPE.SHOP_SAME_DAY;

            if (isShopYourStorePreselectFulfillmentEnabled) {
                deliveryOption = DELIVERY_OPTIONS.SAME_DAY.toLowerCase();
            }
        }

        return { refinements, placeholder, deliveryOption, sotSubType };
    }
);

const withSearchBarHandlerProps = wrapHOC(connect(fields));

export {
    fields, withSearchBarHandlerProps
};
